export default __webpack_public_path__ + "static/dev_hero-37bec6ad8e5858321a8cee365b8e98e8.jpg";